export default __webpack_public_path__ + "static/media/canaryPointCS_logo.4f2979a6.png";